var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar11({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.8377 49.6689C99.8377 77.1002 77.6002 99.3377 50.1689 99.3377C22.7375 99.3377 0.5 77.1002 0.5 49.6689C0.5 22.2375 22.7375 0 50.1689 0C77.6002 0 99.8377 22.2375 99.8377 49.6689Z",
    fill: "#FCEFB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8377 49.6689C99.8377 77.1002 77.6002 99.3377 50.1689 99.3377C22.7375 99.3377 0.5 77.1002 0.5 49.6689C0.5 22.2375 22.7375 0 50.1689 0C77.6002 0 99.8377 22.2375 99.8377 49.6689Z",
    fill: "#FFF9DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1738 30.6416L58.4893 25.3152L59.4614 33.4865L49.3674 33.166L41.6767 46.144L39.1132 60.564L30.2328 62.2842L25.1738 30.6416Z",
    fill: "#F5EA2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3928 35.1238L27.0376 32.9036L28.1605 31.9506L34.0934 30.8221L38.7354 56.3058L36.8128 56.7865L38.0945 60.1512L30.8553 62.2381L26.3928 35.1238Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0103 72.8928L33.5546 72.0761L32.4957 70.7197L31.2151 63.6419L59.333 58.7017L59.8749 60.998L63.5835 59.5507L65.93 68.203L36.0103 72.8928Z",
    fill: "#9855C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3809 69.235L24.5433 36.1315C24.2852 34.6682 24.619 33.1624 25.4712 31.9453C26.3235 30.7281 27.6243 29.8994 29.0876 29.6413L56.6738 24.7766C57.2591 24.6734 57.8615 24.8069 58.3483 25.1478C58.8352 25.4887 59.1667 26.009 59.2699 26.5943L60.8332 34.3629M30.3809 69.235C30.6389 70.6983 31.4677 71.9991 32.6848 72.8513C33.902 73.7036 35.4078 74.0374 36.8711 73.7793L64.4573 68.9146C65.0426 68.8114 65.563 68.4799 65.9039 67.9931C66.2448 67.5062 66.3783 66.9039 66.2751 66.3186L65.4797 61.6007M30.3809 69.235C30.1228 67.7718 30.4567 66.2659 31.3089 65.0488C32.1611 63.8316 33.4619 63.0029 34.9252 62.7448L42.8883 61.2802",
    stroke: "#010101",
    strokeWidth: 4.29395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3083 27.4346L37.7279 25.9442L40.5009 41.6102L35.6234 38.7783L32.0813 43.1005L29.3083 27.4346Z",
    fill: "#1DD59B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4534 27.2227L36.7081 26.1156L38.9664 38.8736L35.2976 36.5137L32.7116 39.9808L30.4534 27.2227Z",
    fill: "#18A0A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6484 33.7227L83.3448 43.6659L76.5007 68.9246L70.3551 67.7746L65.3882 60.4043L53.2113 57.0397L47.7637 60.4043L39.8043 58.9813L46.6484 33.7227Z",
    fill: "#1FA8F4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6504 41.1221L81.0899 44.2196L81.0899 59.2805L76.7582 66.728L74.6504 41.1221Z",
    fill: "#F0D000"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0019 45.9276L54.0563 47.0521L58.1107 48.1766M55.1694 43.0388L52.9432 51.0654M67.6902 52.9946L67.7105 53.0002M74.8849 50.668L74.9052 50.6737M76.2892 40.2525L54.7197 34.27C52.7132 33.714 50.574 33.9141 48.7154 34.8315C46.8569 35.749 45.4111 37.3187 44.6575 39.2372L44.5384 39.5327C43.9991 40.8396 39.9696 50.6135 39.1103 53.7118C38.6675 55.3084 38.8835 57.0173 39.7109 58.4626C40.5383 59.9079 41.9093 60.9712 43.5222 61.4185C45.5494 61.9808 46.8413 61.2586 48.1332 60.5364L51.7866 58.494C52.7556 57.9522 53.904 57.8152 54.9793 58.1132L63.7854 60.5556C64.8606 60.854 65.7743 61.563 66.3258 62.5265L68.4052 66.159C69.1406 67.4434 69.8759 68.7279 71.9031 69.2901C73.516 69.7375 75.2388 69.5323 76.6925 68.7197C78.1461 67.907 79.2116 66.5535 79.6544 64.957C80.5143 61.8567 82.0943 51.4056 82.3052 50.0076C82.3195 49.9035 82.3361 49.7993 82.3548 49.695C82.6977 47.6622 82.2673 45.5716 81.1469 43.8274C80.0265 42.0833 78.2957 40.8095 76.2892 40.2525Z",
    stroke: "#F42085",
    strokeWidth: 4.57778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar11);
export default __webpack_public_path__ + "static/media/avatar11.1e3372e5ea167218f2c3dc96d7ad6ff7.svg";
export { ForwardRef as ReactComponent };